import { render, staticRenderFns } from "./default-time.vue?vue&type=template&id=30fab351"
import script from "./default-time.vue?vue&type=script&lang=js"
export * from "./default-time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports